module.exports = __webpack_public_path__ + "img/BI.99a58d74.png";